module.exports = __webpack_public_path__ + "static/img/yyjc.214c3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yyjc.png
// module id = 6/07
// module chunks = 0